/**
 * MEJORA 1A — Catálogo de metodologías estándar por nivel de riesgo.
 * NO eliminar metodologías existentes; sólo agregar las 4 nuevas (Tripod Beta/Delta,
 * ICAM, DNV SCAT, Comprehensive Cause List).
 */

export const METHODOLOGIES = {
  low: ["5 Whys", "Ishikawa Diagram"],
  medium: ["5 Whys Enhanced", "Ishikawa", "PDCA", "8D Report", "Comprehensive Cause List"],
  high: [
    "Apollo RCA", "Bow-Tie Analysis", "Cause Mapping", "FMEA/FMECA", "8D Advanced",
    "Tripod Beta/Delta", "ICAM",
  ],
  catastrophic: ["TapRooT®", "DNV SCAT", "Fault Tree Analysis", "MORT", "STAMP/STPA"],
};

/** Devuelve unión de metodologías para el riesgo actual + niveles inferiores */
export function methodologiesFor(risk) {
  const order = ["low", "medium", "high", "catastrophic"];
  const idx = order.indexOf(risk || "medium");
  if (idx < 0) return [...new Set(Object.values(METHODOLOGIES).flat())];
  return [...new Set(order.slice(0, idx + 1).flatMap((k) => METHODOLOGIES[k]))];
}

/** Set plano de todas las metodologías estándar */
export const ALL_STANDARD_METHODS = [...new Set(Object.values(METHODOLOGIES).flat())];

/** MEJORA 1B — Descripciones detalladas de las 4 nuevas metodologías */
export const METHODOLOGY_DESCRIPTIONS = {
  "Tripod Beta/Delta": {
    origin: "Shell International + Leiden University",
    year: "1992",
    when_to_apply:
      "Investigaciones complejas en O&G (offshore/onshore) donde se requiere identificar tanto causas inmediatas como fallas latentes del sistema de gestión.",
    steps: [
      "Construir el árbol Tripod (Event → Agent → Object).",
      "Identificar barreras fallidas o ausentes en cada brazo del árbol.",
      "Vincular cada falla a una de las 11 Basic Risk Factors (BRF).",
      "Trazar las precondiciones organizacionales (fallas latentes).",
      "Generar recomendaciones por BRF afectado.",
    ],
    certification: "Tripod Practitioner / Lead Investigator",
  },
  ICAM: {
    origin: "BHP Billiton (basado en James Reason)",
    year: "2000",
    when_to_apply:
      "Análisis de accidentes organizacionales en minería y O&G; útil cuando se sospecha de fallas en múltiples capas (defensas, equipo, tarea, organización).",
    steps: [
      "Recolectar PEEPO (People/Equipment/Environment/Procedures/Organization).",
      "Identificar Defensas Ausentes o Fallidas.",
      "Trazar Acciones Individuales/Equipo (errores y violaciones).",
      "Identificar Condiciones de Tarea/Ambiente.",
      "Trazar Factores Organizacionales que explican las condiciones.",
    ],
    certification: "ICAM Lead Investigator",
  },
  "DNV SCAT": {
    origin: "Det Norske Veritas (basado en F. Bird)",
    year: "1985",
    when_to_apply:
      "Análisis de pérdidas y eventos catastróficos siguiendo el modelo de Causalidad de Pérdidas (Loss Causation Model).",
    steps: [
      "Identificar la pérdida real o potencial.",
      "Reconstruir el incidente o contacto con energía.",
      "Identificar causas inmediatas (actos y condiciones inseguras).",
      "Trazar causas básicas (factores personales y de trabajo).",
      "Identificar la falta de control (sistema de gestión).",
    ],
    certification: "DNV Loss Causation Trainer / Investigator",
  },
  "Comprehensive Cause List": {
    origin: "CCPS / AIChE",
    year: "2003",
    when_to_apply:
      "Verificación de cobertura sistemática de causas potenciales en investigaciones de procesos químicos y plantas industriales; útil como checklist complementario.",
    steps: [
      "Recorrer las 26 categorías del catálogo (técnicos, humanos, sistema de gestión, externos).",
      "Marcar las categorías aplicables al evento.",
      "Profundizar en cada categoría marcada con preguntas guía del CCPS.",
      "Documentar evidencia de soporte por causa identificada.",
      "Verificar que no haya categorías omitidas antes de cerrar la investigación.",
    ],
    certification: "CCPS Process Safety Investigator",
  },
};
